module.exports = __webpack_public_path__ + "img/courses-scholarship.ee2fb260.svg";